export const ROUTES_URL = {
  homepage: () => '/homepage',
  car_list: () => '/car-list',
  car_detail: (id) => `/car-detail?vin=${id}`,
  certification_progress: (id) => `/certification-progress?vin=${id}`,
};
